import React, { useState, useEffect } from 'react';
import { Checkbox, Button } from 'antd';
import DashboardModal from './DashboardModal';
import { useOneButtonStore } from '../../../../store/oneButtonStore';

export interface ContractSignedProductLine {
    apiProductCategory: string;
    displayName: string;
    selected: boolean;
}

export interface ContractSignedProductsModalProps {
    open: boolean;
    title: string;
    instruction: string;
    lineItems: ContractSignedProductLine[];
    onClose: (selectedApiCategories: string[] | null) => void;
}

export const ContractSignedProductsModal: React.FC<ContractSignedProductsModalProps> = ({
    open,
    title,
    instruction,
    lineItems,
    onClose,
}) => {
    const theme = useOneButtonStore((s) => s.theme);
    const [selectedItems, setSelectedItems] = useState<string[]>([]);

    // Initialize selection when modal opens
    useEffect(() => {
        if (open) {
            const initialSelected = lineItems
                .filter((item) => item.selected !== false)
                .map((item) => item.apiProductCategory);
            setSelectedItems(initialSelected);
        }
    }, [open, lineItems]);

    const handleCancel = () => {
        onClose(null);
    };

    const handleSubmit = () => {
        onClose(selectedItems);
    };

    const handleCheckboxChange = (category: string, checked: boolean) => {
        if (checked) {
            setSelectedItems((prev) => [...prev, category]);
        } else {
            setSelectedItems((prev) => prev.filter((item) => item !== category));
        }
    };

    const canSubmit = selectedItems.length > 0;

    return (
        <DashboardModal
            title={title}
            open={open}
            onClose={handleCancel}
            width={520}
            maskClosable={false}
            theme={theme}
            footer={
                <>
                    <Button key="cancel" onClick={handleCancel}>
                        Cancel
                    </Button>
                    <Button
                        key="submit"
                        type="primary"
                        disabled={!canSubmit}
                        onClick={handleSubmit}
                    >
                        Submit
                    </Button>
                </>
            }
        >
            <div className="obd-contract-signed-modal-content" style={{ padding: '10px 0' }}>
                <p style={{ marginBottom: '16px', fontWeight: 500 }}>{instruction}</p>
                <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
                    {lineItems.map((item) => (
                        <Checkbox
                            key={item.apiProductCategory}
                            checked={selectedItems.includes(item.apiProductCategory)}
                            onChange={(e) => handleCheckboxChange(item.apiProductCategory, e.target.checked)}
                        >
                            {item.displayName}
                        </Checkbox>
                    ))}
                </div>
            </div>
        </DashboardModal>
    );
};
